export default __webpack_public_path__ + "static/how_it_work_3-95287bb5b029ab15c0dc84b4e9059bd7.png";